
import React, {useState ,useEffect} from 'react';
import {Link} from "react-router-dom";

import useGoogleCharts from '../../components/useGoogleCharts.js';
import {_getCoutryGoogleChartName} from '../../helpers/helpers.js'
import CountriesLeadList from '../../components/countriesLeadList.js'
import TLDLeadList from '../../components/tldLeadList.js'
import GeoDistribution from '../../components/geoDistribution.js'
import DomainTable from '../../components/domainTable.js'
import CountryFlagAndName from '../../components/countryFlagAndName.js'
import DistributionByPopularityChart from '../../components/technologyDistributionChart.js'
import TechnologySmallIcon from '../../components/technologySmallIcon.js'
import CopyLink from '../../components/copyLink.js'
import CveTitle from '../../components/cveTitle.js'
import {DataSetCWEData} from '../../components/structuredData.js'
import {
    RtHeader, 
    Domain, 
    RtButton, 
    TechnologyDomains, 
    TechnologyGeoData, 
    TLDData, 
    FullTechnologyGeoData,
    Distribution
} from '../../../../server/routes/route-types'

import {
	_printDate, 
	_printShortDate,
	_printMediumDate,
	_printNumber, 
	_printPercent, 
	_extractWebsiteFromURL,
	_isGoogleIcon,
	_getGoogleIcon,
    _countryNameFromCode
	} 
from '../../helpers/helpers'

import {RtCVEData, RtCWEStatsResult} from '../../../../server/routes/cwe.js'

interface CWEProps {
    server: string;
    pageData: unknown;
}

interface ComponentProps {
    props: RtCWEStatsResult;
    google?: wts_approved_any;
}

function TrimCWEPrefix(descr: string): string {
    // remove CWE-
    return descr.substring(4)
}
        
export default function CWE({server, pageData}: CWEProps) {

	let [data, setData] = useState(pageData as RtCWEStatsResult);
	const google = useGoogleCharts();

	return (
		<>
				<DataSetCWEData cwe={data.CWE} url={data.CWE} title={data.CWEInfo!.Title} />
				<section className="section section-sm">
				<div className="container">
					<div className="row row-50">
						<div className="col-md-8 col-lg-8 col-xl-8">
							<CWELeftPanel props={data} google={google}/>
						</div>
						<div className="col-md-4 col-lg-4 col-xl-4">
							<CWERightPanel props={data} />
						</div>					
					</div>
                    <CWEBottomPanel props={data} google={google} />
				</div>				
			</section>
		</>
	)
};

function CWEBottomPanel({props, google}: ComponentProps) {   


	return (
		<>
			{/* usage is not that interesting.*/}
			{/* <CWEUsageStats props={props}/>*/ }

			{/*	<TechnologyDevelopments props={props}/> */ }
			{/* name intentionaly not set in DistributionByPopularityChart*/ }
	
			<RecentCVE props={props}/>
			<PopularCVE props={props}/>
	
			<GeoDistribution link={props.CanonicalURL} geoData={props.GeoData} google={google}/>

			<CWEWebsites props={props}/>
		</>
	)
}

function Severity(props: {severity: string}) {
	if (props.severity == 'High')
		return (<>Severity: <span style={{color: 'red'}}><b>{props.severity}</b></span></>)
	else if (props.severity == 'Med')
		return <>Severity: <span style={{color: 'orange'}}><b>{props.severity}</b></span></>
	else if (props.severity == 'Med')
		return (<>Severity: <span style={{color: 'yellow'}}><b>{props.severity}</b></span></>)
	else if (props.severity == 'Info')
		return (<>Severity: <span style={{color: 'gray'}}><b>{props.severity}</b></span></>)
	else
		return (<></>)
}
function CWELeftPanel({props, google}: ComponentProps) {
	if (!props.CWEInfo) return (<>Unknown CWE number</>);

	return (
		<>
			<h3 style={{wordWrap: 'break-word'}}>{props.PageTitle}</h3>
			<br/>
            <b>{props.CWEInfo.Title}</b>
			<br/>
			<br/>
            {props.CWEInfo.Description}
			<br/>
			<br/>
			{
			/*	<Severity severity={props.CWEInfo.Severity}/>
			<br/>
			<br/> */
			}
			<hr/>
			{
				!props.DomainCount && 
					<NoDomainCWE props={props}/>
			}
			{
				props.DomainCount != 0 &&
					<HasDomainCWE props={props}/>
			}
			<hr/>
			<br/>
			<hr/>
			<DistributionByPopularityChart link={props.CanonicalURL} distribution={props.DistributionByPopularity}
				 google={google}
				 subtitle={`The correlation between website exposure to ${props.CWE} and the relative popularity of the website`}/>	 

			{/*<hr/>	*/} 
			<br/>		
			<br/>
            {/** 
			<div>
				<h3>References</h3>
				<br/>
				<a
					className="link-hover" 
					rel="noopener nofollow" 
					target="_blank" 
					href={props.CWEInfo.Reference} 
				>
					{props.CWEInfo.Reference} 
				</a>	
				<br/>			
				<br/>
			</div>
			<hr/>
			<br/>
			{
				props.DomainCount &&
					<CWEContent props={props}/>
			}
            */}
		</>
	)
}


function CWERightPanel({props}: {props: RtCWEStatsResult}) {
	return (
		<div className="row row-35 row-lg-50">
			<div className="col-sm-12 col-lg-12">
				<CWEAvailableReports props={props}/>
				<CWEDetails props={props}/>
				<CWEExternalLinks props={props}/>

			    <CountriesLeadList name={props.CWE} reporttype='none'  geoData={props.GeoData} />
				<TLDLeadList name={props.CWE} reporttype='none' tlds={props.TLDs}/>	
			</div>
		</div>
	)							
}

function NoDomainCWE({props}: {props: RtCWEStatsResult}) { 

	return (
		<div className="row row-50">
			<div className="col-12">
                {
				<p>We did not find any websites that are vulnerable to {props.CWE} </p>
                }
			</div>
		</div>
	)
}


function HasDomainCWE({props}: {props: RtCWEStatsResult}) {

	return (
		<>
			<CWEBrag props={props}/>
		</>
	)
}

function CWEBrag({props}: {props: RtCWEStatsResult}) {
    let CWE = props.CWE;
    let title = props.Domains.Header.Subtitle;

	return (
		<>
			<p>
				We have discovered&nbsp;
				<Link 
					to={props.Domains.Button.Href}
					className="link-hover" 
					title={props.Domains.Header.Subtitle} 
					rel="noopener nofollow" 
				> 
				<b>{_printNumber(props.DomainCount)} live websites</b>
				</Link>&nbsp;that are affected by {CWE}.
			</p>
			<p>
				<Link 
					to={`/contact-us`}
					className="button button-secondary" 
					title={`Contact us`} 
					rel="noopener nofollow" 
				>
					Contact us to get more info
				</Link>
			</p>
			{
				/*
			<p>
				<Link 
					to={`/create-report?CWE=${CWE}`}
					className="button button-secondary" 
					title={`Download list of websites that are using tag ID ${CWE}`} 
					rel="noopener nofollow" 
				>
					Download Lead List
				</Link>
			</p>				 
			*/
			}

			<br />
			<br />
		</>
	)
}


function CWEUsageStats({props}: {props: RtCWEStatsResult}) {
	// Disabled because ont that interesting

	return (
		<>
			<div className="row row-50">
			<div className="col-12">
				<h3 className="text-left">{props.CWE} statistics</h3>
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
						<tr>
							<td>Websites vulnerable to {props.CWE}</td>
							<td>
								<span className="icon text-primary">
									<Link 
										to={props.Domains.Button.Href}
										className="link-hover" 
										title={props.Domains.Header.Subtitle} 
									>
										<b>{_printNumber(props.DomainCount)}</b> websites
									</Link>
								</span>
							</td>
						</tr>
						{
							// props.Usage != undefined && props.Usage.LastMonthChange &&
							// 	<tr>
							// 		<td>Change from last month</td>
							// 		<td>
							// 			<span 
							// 				className="icon  mdi mdi-arrow-down" 
							// 				style={{color: 'red'}}
							// 			>
							// 				<b>
							// 					{props.Usage.LastMonthChange}%
							// 				</b>
							// 			</span>
							// 		</td>
							// 	</tr>
						}
						{
							props.Usage != undefined && props.Usage.MostPopularCountry &&
    							<tr>
                                    <td>
                                        Most prevalent in the country
                                    </td>
                                    <td>
                                        <b>
                                            <CountryFlagAndName countryCode={props.Usage.MostPopularCountry.Country} />
                                        </b>
                                    </td>
                                </tr>  
                        }
                        {    
							props.Usage != undefined && props.GeoData.Countries && props.Usage.DomainCount &&
                            <tr>
                                <td>
                                	Websites affected by {props.CWE} hosted in {_countryNameFromCode(props.Usage.MostPopularCountry.Country)}
                                </td>
                                <td>
                                    <b>
                                        {_printPercent(props.GeoData.Countries[0].DomainCount/props.Usage.DomainCount)}%
                                    </b>
                                </td>
                            </tr>
						}

					</tbody>
				</table>
			</div>
		</div>
	</>
	)
}

function CWEWebsites({props}: {props: RtCWEStatsResult}) {
	if (!props.Domains) return (<></>);
	if (!props.Domains.Domains) return (<></>);
	if (!props.Domains.Domains.length) return (<></>);

	return (
		<DomainTable domainList={props.Domains}/>
	)
}

function CWEAvailableReports({props}: {props: RtCWEStatsResult}) {
    if (!props || !props.DomainCount) return null;

	return (
		<>
			<article className="box-bordered">
				<h4>Available Reports</h4>
				<div>
					<ul>
						<li>
							<Link 
								to={props.Domains.Button.Href}
								className="link-hover" 
								title={props.Domains.Header.Subtitle}
							>
								Website List
							</Link>
						</li>                                             
					</ul>      
				</div>
			</article>
			<br />
		</>
	)
}

function CWEDetails({props}: {props: RtCWEStatsResult}) {
	if (!props.CVECount) return (<></>);
	return (
		<>
			<article className="box-bordered">
				<h4>CVEs</h4>
				<ul className="list-marked">
					<li>Count - {_printNumber(props.CVECount)}</li>				
				</ul>
			</article>
			<br/>			
		</>
	)
}


function CWEExternalLinks({props}: {props: RtCWEStatsResult}) {
	if (!props.CWEInfo) return (<></>);
	return (
		<>
			<article className="box-bordered">
				<h4>CWE References</h4>
				<ul className="list-marked">				
					<li>
						<b>
						<a
							className="link-hover" 
							rel="noopener nofollow" 
							target="_blank" 
							title={`${props.CWEInfo.Description}`}				
							href={`https://cwe.mitre.org/data/definitions/${TrimCWEPrefix(props.CWE)}`}
						>
							cwe.mitre.org &nbsp;&nbsp;&nbsp;
							<span style={{color:'black'}} className="icon text-right fa fa-external_link"/>
						</a>
						</b>
					</li>
				</ul>
			</article>				
			<br/>
		</>
	)
}

function CVERow({cve}: {cve: RtCVEData})
{
	return (<>
		<tr>			
			<td>
				{_printShortDate(cve.DatePublished)}
			</td>	
			<td>
				<Link 
					className="link-hover word-break" 
					title={cve.CVEId} 
					to={`/cve/${cve.CVEId}`}
				>
					<b>{cve.CVEId}{' '}</b>
				</Link>				
			</td>					
			<td>
				<CveTitle cve={cve} />	
			</td>				
			<td>				
				<Link 
					className="link-hover word-break" 
					title={cve.CVEId} 
					to={`/cve/${cve.CVEId}/websites`}
				>
					<b>{_printNumber(cve.DomainCount)}</b>
				</Link>		
			</td>

		</tr>
	</>)
}
interface CVEListProps {
    link: string;
    anchor: string;
    title: string;
    subtitle: string;
    list: RtCVEData[];
}

function CVEList({link,anchor,title, subtitle,list}: CVEListProps)
{	
	return (
<>
{/*	<div className="table-outer table-rounded table-responsive-lg">  */}
<div className="row row-50">
	<div className="col-12">
		<h3 className="text-left" id={anchor}>{title}
		<CopyLink link={link}  anchor={anchor}/>
		</h3>
		{subtitle}
		<table className="table-custom table-custom-striped table-custom-primary  ">
			<thead>
			<tr>
				<th style={{width: '15%'}}>Discovered</th>
				<th style={{width: '15%'}}>CVE</th>
				<th style={{width: '55%'}}>Description</th>
				<th style={{width: '15%'}}>Websites</th>
			</tr>
			</thead>
				<tbody>
					{
						list.map((cve, indexKey) => {
						return (
							<CVERow cve={cve} key={indexKey} />
						)
					})
				}	
			</tbody>
		</table>
		</div>
	</div>
</>
	)
}

function PopularCVE({props}: {props: RtCWEStatsResult}) {
	if (!props.MostPopularCVEs.length) return (<></>);
	
	return (
		<>	
			<CVEList 
				list={props.MostPopularCVEs} 
				link={props.CanonicalURL!}
				anchor='popular'
				title = 'The most widespread CVEs' 
				subtitle = {`List of the most common CVEs that are part of ${props.CWE}` }
				/>
		</>
	)
}


function RecentCVE({props}: {props: RtCWEStatsResult}) {
	if (!props.MostRecentCVEs.length) return (<></>);

	return (
		<>	
			<CVEList 
				list={props.MostRecentCVEs} 
				link={props.CanonicalURL!}
				anchor='recent'
				title = 'Newest CVEs'
				subtitle = {`List of the most recent CVEs that are part of ${props.CWE}` }

				/>
		</>
	)
}


